<template>
    <div :class="{ show: visible, hide: !visible }" class="l-mask">
        <div @click="closeTask" class="l-close-display"></div>
        <div :class="{ show: visible, hide: !visible }" class="l-display">
            <div class="l-section">
                <span class="l-week">备战资源</span>
                <span class="l-close"><i class="icon-lily icon-lily-guanbi1" @click="closeTask"></i></span>
            </div>
            <div class="l-level-list-section-box">
                <template v-if="listData.length">
                    <MenuList
                        class="player-list"
                        :menu-list="listData"
                        @play="handlePlay" />
                </template>
                <div v-else class="l-more-no-data">
                    <span>暂无数据</span>
                </div>
            </div>
            <div class="l-footer"></div>
        </div>
    </div>
</template>

<script>
import Study2Model from '@/models/study2'
import { PREVIEW_ELEMENT } from '@/constants/preview'
import MenuList from '../MenuList.vue';
const study2 = new Study2Model()

export default {
    name: "l-task",
    props: {
        visible: {
            type: Boolean,
        },
        list: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    components: {
        MenuList,
    },
    watch: {},
    data() {
        return {
            listData: [],
            showPreview: false,
        };
    },
    methods: {
        closeTask() {
            this.$emit("closeTask");
        },
        handleGetList() {
            study2.previewData().then(res => {
                // Add expanded property to items with sourceList
                const processedData = res.data?.map(item => ({
                    ...item,
                    type: this.getRecordType(item),
                    name: item.videoName || item.recordName || '整看提示',
                    hasChildren: item.sourceList && item.sourceList.length > 0,
                }));
                this.listData = processedData || [];
            })
        },
        getRecordType(item) {
            if (item.videoName) {
                return PREVIEW_ELEMENT.VIDEO
            } else if (item.recordName) {
                return PREVIEW_ELEMENT.AUDIO
            } else {
                return PREVIEW_ELEMENT.TIPS
            }
        },
        toggleExpand(index) {
            this.$set(this.listData[index], 'expanded', !this.listData[index].expanded);
        },
        handlePlay(item) {
            this.$router.push({
                path: `/learning/${item.type}`,
                query: {
                    id: item.id,
                    resource: item.videoResource || item.recordResource,
                    name: item.recordName || item.videoName,
                },
            })
        }
    },
    mounted() {
        this.handleGetList()
    },
};
</script>

<style lang="stylus" scoped>
@import "./l-task.styl";
</style>
